import Lottie from "lottie-react";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import updateAnimation from "../../../Assets/animation/update.json";
import AuthUser from "../../../Hooks/authUser";
import { Icon } from "@iconify/react";

const EditProfile = () => {
  const { userInfo } = AuthUser();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    fetchUserData();
  }, [userInfo]);

  const fetchUserData = async () => {
    try {
      const response = await fetch(
        `https://servercareseebd.careseebd.com/api/v1/user/${userInfo._id}`,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("careSeeAccessToken")}`,
          },
        }
      );
      if (response.ok) {
        const userData = await response.json();
        setFormData({
          name: userData.data.name || "",
          email: userData.data.email || "",
          phone: userData.data.phone || "",
        });
      } else {
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch(
        `https://servercareseebd.careseebd.com/api/v1/user/${userInfo._id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        toast.success("Profile updated successfully!");
        fetchUserData();
      } else {
        console.error("Profile update failed!");
        toast.error("An error occurred.");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  return (
    <div className="max-w-5xl mx-auto select-none space-y-6 animate-fade-in">
      {/* Header card */}
      <div className="flex items-center gap-3 bg-white p-6 rounded-2xl border border-slate-100 shadow-sm">
        <div className="p-3 bg-indigo-50 text-indigo-600 rounded-xl">
          <Icon icon="solar:user-id-bold" className="w-6 h-6" />
        </div>
        <div>
          <h1 className="text-lg font-black text-slate-800 tracking-tight">Profile Configurations</h1>
          <p className="text-xs text-slate-400 font-semibold mt-0.5 font-semibold">Update your administrator details and primary contact information</p>
        </div>
      </div>

      {/* Main card */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 lg:p-8 grid grid-cols-1 md:grid-cols-12 items-center gap-8 lg:gap-12">
        <div className="md:col-span-5 flex justify-center max-w-sm mx-auto w-full">
          <Lottie animationData={updateAnimation} className="w-full max-h-72 object-contain" />
        </div>
        <form className="md:col-span-7 space-y-4" onSubmit={handleSubmit}>
          <div className="space-y-4">
            {/* Name input */}
            <div className="space-y-1.5">
              <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">Full Name</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
                  <Icon icon="solar:user-linear" className="w-4 h-4" />
                </div>
                <input
                  className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-xs font-semibold text-slate-800"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Email input */}
            <div className="space-y-1.5">
              <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">Email Address</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
                  <Icon icon="solar:letter-linear" className="w-4 h-4" />
                </div>
                <input
                  className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-xs font-semibold text-slate-800"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Phone input */}
            <div className="space-y-1.5">
              <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">Phone Number</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
                  <Icon icon="solar:phone-linear" className="w-4 h-4" />
                </div>
                <input
                  className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-xs font-semibold text-slate-800"
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </div>

          <div className="pt-2">
            <button
              className="w-full py-2.5 bg-gradient-to-r from-cyan-500 to-blue-600 hover:opacity-95 text-white font-extrabold text-xs rounded-xl shadow-md shadow-cyan-500/10 hover:-translate-y-0.5 transition-all duration-300 cursor-pointer flex items-center justify-center gap-2"
              type="submit"
            >
              <Icon icon="solar:diskette-bold" className="w-4 h-4" />
              <span>Update Profile Info</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProfile;
